import create from 'zustand';
import { Sources, ThumbsData, VideoContentData, VideoFileData } from '../Components/Player/PlayerModels';

export interface PlayerProps {
  playerState: PlayerModel;
  setPlayerState: (data: PlayerModel) => void;
}

export type PlayerModel = {
  contentData: VideoContentData | null;
  contentConfigs: VideoFileData | null;
  sources: Sources | null;
  vttData?: ThumbsData | null;
  captionState: {
    prevCaptionIndex: number,
    selectedCaptionLang: {
      lang: string,
      label: string,
    },
  },
  audioState?: {
    selectedLang: string,
  },
  showingNextEpisode: boolean;
}

const UsePlayerProps = create<PlayerProps>((set) => ({
  playerState: {
    contentData: null,
    contentConfigs: null,
    sources: null,
    vttData: null,
    captionState: {
      prevCaptionIndex: -1,
      selectedCaptionLang: {
        lang: 'off',
        label: 'خاموش',
      },
    },
    audioState: {
      selectedLang: '',
    },
    showingNextEpisode: true,
  },
  setPlayerState: (data: PlayerModel) => {
    set(() => ({
      playerState: {
        contentData: data.contentData,
        contentConfigs: data.contentConfigs,
        sources: data.sources,
        vttData: data.vttData,
        captionState: {
          prevCaptionIndex: data.captionState.prevCaptionIndex,
          selectedCaptionLang: data.captionState.selectedCaptionLang,
        },
        audioState: data.audioState,
        showingNextEpisode: data.showingNextEpisode,
      },
    }));
  },
}));

export default UsePlayerProps;
